/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { css } from 'styled-components';
import FeatureItems from '../../Elements/FeatureItem/FeatureItems';
import FeatureHeader from '../../Elements/Header';
import FeatureButtonRow from '../../Elements/CtaButtons';
import Block from '@vfuk/core-block';
import SimpleGrid from '@vfuk/core-simple-grid';
import { imageBlock, imageContainer, assessmentPage, SimpleGridWrapper } from './styles/SectionFeatureRow.styles';
import { SectionFeatureRowProps } from './types/SectionFeatureRow.types';

const SectionFeatureRow = ({
  backgroundColor,
  featureImage,
  featureHeader,
  featureItems,
  featureButtons,
}: SectionFeatureRowProps) => {

  const imageCss = [];
  let itemSpringSize: any

  if (featureImage && featureImage.page === "Assessment") {
    imageCss.push(assessmentPage);
    itemSpringSize = "large";
  } else {
    imageCss.push(imageBlock);
    itemSpringSize = "small";
  }

  return (
    <Block className='section' css={css`
        ${'background-color:var(--' + backgroundColor + ');'}
      `}>
      <SimpleGridWrapper size={itemSpringSize}>
        <SimpleGrid
          columns={{
            sm: 1
          }}
          justify='center'
          verticalAlign='center'
        >
          {featureImage && (
            <div css={imageContainer}>
              <GatsbyImage
                image={getImage(featureImage.mainImage) as IGatsbyImageData}
                css={imageCss}
                alt={featureImage.name}
              />
            </div>
          )}
        </SimpleGrid>
      </SimpleGridWrapper>
      <SimpleGridWrapper size='large'>
        <SimpleGrid
          columns={{
            sm: 1
          }}
          justify='center'
          verticalAlign='center'
        >
          {featureHeader && <FeatureHeader content={featureHeader} />}
        </SimpleGrid>
      </SimpleGridWrapper>
      <SimpleGridWrapper size='large'>
        <SimpleGrid
          columns={{
            sm: 1,
            md: featureItems.length,
          }}
          verticalAlign='top'
        >
          {featureItems.map(items => {
            return <FeatureItems key={items.id} items={items} />;
          })}
        </SimpleGrid>
      </SimpleGridWrapper>
      <SimpleGridWrapper size='small'>
        <SimpleGrid
          columns={{
            sm: 1
          }}
          justify='center'
          verticalAlign='center'
        >
          {featureButtons && (
            <FeatureButtonRow
              key={featureButtons.id}
              buttonRowAlignment={featureButtons.buttonRowAlignment}
              buttons={featureButtons.buttons}
            />
          )}
        </SimpleGrid>
      </SimpleGridWrapper>
    </Block>
  );
};

export default SectionFeatureRow;
